import React, {memo} from "react"
import {PasswordContainer} from "../../../../../../components/PasswordContainer"
import {SubMenuComponent} from "../../../../../../components/SubMenu"
import iconTest from "../../../../../../assets/images/icons/settings/log.png"
import {SettingsPageContainer} from "../../../../../../components/Settings/SettingsPageContainer"
export const NetworkTestMenuScreen = memo(function NetworkTestMenuScreen() {
    return (
        <PasswordContainer requiredRole="service" isFullscreen={true}>
            <SettingsPageContainer buttons={[]} className="service-edit" backUrl={"/settings/advanced-settings/test"}>
                <div className="content-divider">
                    <div className="sub-menu-content-divider">
                        <SubMenuComponent
                            icon={iconTest}
                            name={"Ping Testi"}
                            path={"/settings/advanced-settings/test/network/ping-test"}
                        />
                        <SubMenuComponent
                            icon={iconTest}
                            name={"Trace Root Testi"}
                            path={"/settings/advanced-settings/test/network/trace-root-test"}
                        />
                        <SubMenuComponent
                            icon={iconTest}
                            name={"Hız Testi"}
                            path={"/settings/advanced-settings/test/network/speed-test"}
                        />
                    </div>
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
